import type { AxiosInstance } from 'axios'
import type {
    IAccountData,
    IChildProtectAccepted,
    IGuardianAccount,
    IRodoAccepted,
} from '@/typings/account'
import { NO_CONTENT_CODE } from '@/config/httpCodes.ts'

export default (axios: AxiosInstance) => ({
    getMyAccount: async (): Promise<IAccountData> => {
        const { data } = await axios.get<IAccountData>('/guardian/account/guardians/me')

        return data
    },

    getIsRodoAccepted: async (): Promise<IRodoAccepted> => {
        const { data } = await axios.get<IRodoAccepted>('/guardian/account/guardians/rodo-accepted')

        return data
    },

    getIsChildProtectAccepted: async (): Promise<IChildProtectAccepted> => {
        const { data } = await axios.get<IChildProtectAccepted>(
            '/guardian/account/guardians/child-protect-accepted',
        )

        return data
    },

    acceptRodo: async (): Promise<boolean> => {
        const { status } = await axios.patch('/guardian/account/guardians/rodo/accept')

        return status === NO_CONTENT_CODE
    },

    acceptChildProtect: async (): Promise<boolean> => {
        const { status } = await axios.patch('/guardian/account/guardians/child-protect/accept')

        return status === NO_CONTENT_CODE
    },

    getGuardiansByIds: async (ids: string[]): Promise<IGuardianAccount[]> => {
        const { data } = await axios.post<IGuardianAccount[]>(
            '/guardian/account/guardians/by-ids',
            {
                accountIds: ids,
            },
        )

        return data
    },
})
